import React from 'react';
import { ArrowUpIcon, MailIcon, MapPinIcon } from 'lucide-react';
import { scrollToTop } from '../../utils/scroll';
type LegalContactCardProps = {
  email: string;
  address: string;
};
export function LegalContactCard({
  email,
  address
}: LegalContactCardProps) {
  return <div className="rounded-[14px] bg-canvas-warm p-6 sm:p-8" data-id="element-694" data-mp="1yu7a75k2sou9">
      <h2 className="text-[20px] font-semibold tracking-[-0.02em] text-ink" data-id="element-695" data-mp="1yupbwhpibv9k">Questions about this policy?</h2>
      <p className="mt-2 text-[15px] leading-[1.6] text-ink-muted" data-id="element-696" data-mp="2mkjnkvy3bds8">Our team is happy to explain anything on this page.</p>
      <ul className="mt-5 space-y-3" data-id="element-697" data-mp="2ctyicpnwvb0c">
        <li className="flex items-center gap-3 text-[15px] font-medium text-ink" data-id="element-698" data-mp="2csx6iiz2mkhk">
          <MailIcon className="h-4 w-4 text-brand" aria-hidden="true" data-id="element-699" data-mp="2hsji6nz93so9" />
          {email}
        </li>
        <li className="flex items-center gap-3 text-[15px] font-medium text-ink" data-id="element-700" data-mp="35i43hdivn20p">
          <MapPinIcon className="h-4 w-4 text-brand" aria-hidden="true" data-id="element-701" data-mp="3a92mikv92e7n" />
          {address}
        </li>
      </ul>
      <button type="button" onClick={scrollToTop} className="mt-7 inline-flex h-11 items-center gap-2 rounded-[7px] border border-ink/20 bg-white px-4 text-[14px] font-semibold text-ink transition-colors duration-150 ease-out hover:border-ink/45 print:hidden" data-id="element-702" data-mp="1dkgsk7kn5gsp">
        <ArrowUpIcon className="h-4 w-4" aria-hidden="true" data-id="element-703" data-mp="1ijjql827emr6" />
        Back to top
      </button>
    </div>;
}